"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/nb");

require("moment/locale/nn");

require("moment/locale/sv");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {}
}));

const StatusDate = ({
  className,
  datetime,
  locale = "nb",
  format = "relative",
  children
}) => {
  const classes = useStyles();

  if (!datetime && children) {
    datetime = children;
  }

  if (!datetime) {
    return false;
  } // format value


  _moment.default.locale(locale);

  let date;

  if (format === "relative") {
    date = (0, _moment.default)(datetime).fromNow();
  } else if (format) {
    date = (0, _moment.default)(datetime).format(format);
  }

  return _react.default.createElement("time", {
    datetime: datetime,
    className: className || classes.root
  }, date);
};

StatusDate.propTypes = process.env.NODE_ENV !== "production" ? {
  datetime: _propTypes.default.string,
  locale: _propTypes.default.string,
  format: _propTypes.default.string
} : {};
var _default = StatusDate;
exports.default = _default;
module.exports = exports.default;